// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"16bd67e3","152":"b7638489","322":"697e73cb"}[chunkId] + ".chunk.js";
};